<div id="spring-break">

    <div class="spring-break_banner">
        <!--<div class="overlay-layer"></div>-->

        <div class="go_button sm square" routerLink="../home"
             style="position:absolute; top:20px; left:20px; z-index: 3; background:white; color:#333;">
            <i class="icon-left-open"> Back To Games</i>
        </div>

        <div class="container">
            <div class="content">
                <div class="logo">
                    <img src="assets/img/spring-break/spring-logo.png" width="280" alt="">
                </div>

                <div class="text">
                    <img src="assets/img/spring-break/rainbow-six-siege/r6s-text.png" alt="">

                </div>
            </div>
        </div>
    </div>

<app-tournament-template [gameName]="'rainbow-six-siege'" ></app-tournament-template>


    <app-covid19-advice></app-covid19-advice>

    <app-footer></app-footer>
</div>